export const VendorErrorCategory = {
  CATEGORY_UNKNOWN: 'CATEGORY_UNKNOWN',
  CONNECTIVITY: 'CONNECTIVITY',
  POWER_OPS: 'POWER_OPS',
  ACCESS_CONTROL: 'ACCESS_CONTROL',
  ENTRY_CLOSURE: 'ENTRY_CLOSURE',
  SAFETY_ALARM: 'SAFETY_ALARM',
  PRESENCE: 'PRESENCE',
  SYSTEM_HEALTH: 'SYSTEM_HEALTH',
  MAINTENANCE: 'MAINTENANCE',
  MOVEMENT: 'MOVEMENT',
  AUTOMATION: 'AUTOMATION',
  ENERGY_BATTERY: 'ENERGY_BATTERY',
  FLUID_FLOW: 'FLUID_FLOW',
  THERMAL: 'THERMAL',
} as const;

export type VendorErrorCategory =
  (typeof VendorErrorCategory)[keyof typeof VendorErrorCategory];
